export const RequestErrorMessages = {
  ProxyHasBeenDeleted: 'Proxy has been deleted',
  ProxyNotFound: 'Proxy not found',
} as const;
